import React, { useEffect, useState, useCallback } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Input } from 'Components/Input'
import Button from '@mui/material/Button'
import ComboBox from 'Components/ComboBox'
import ChecklistPng from 'Components/images/checklist.png'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import AddIcon from '@mui/icons-material/Add'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import CreateEvent from './CreateEvent'
import AddContact from './AddContact'
import CreateDocumentsForm from './CreateDocument'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 500,
  borderRadius: 2,
  bgcolor: 'background.paper',
  boxShadow: 24,
}
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 450,
  borderRadius: 2,

  bgcolor: 'background.paper',
  boxShadow: 24,

  pt: 2,
  pb: 2,
}
function CheckListModal({ setCheckListIds }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [showContactModel, setShowContactModel] = useState(false)
  const [checked, setChecked] = useState([])
  const [contacts, setContacts] = useState([])
  const [event, setEvent] = useState([])
  const [checkList, setCheckList] = useState([])

  useEffect(() => {
    fetchCeckList()
  }, [])
  const fetchCeckList = async () => {
    const url = urls.getAllCheckList + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        if (!v.TaskId) filterTypes.push({ label: `${v.NomTask}`, id: v.id })
      })
      setCheckList([...filterTypes])
    }
  }
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    setChecked(newChecked)
  }
  const [showModal, setShowModal] = useState(false)
  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  })
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      NomTask: '',
    },
  })
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    setChecked([])
    setContacts([])
    setEvent([])
    reset()
  }
  const addCheckList = async () => {
    setCheckListIds(checked)
    handleClose()
  }
  const onSubmit = async (data) => {
    let payload = {}
    payload = {
      ...data,
      Contacts: contacts,
      EventData: event,
    }
    const response = await makePostRequest(urls.checkListOperations, payload, {}, true)
    if (response.status === 201) {
      fetchCeckList()
      setChecked([])
      setContacts([])
      setEvent([])
      reset()
      setValue('NomTask', '')
    }
  }

  return (
    <>
      <Button onClick={handleOpen}>
        <img alt="" src={ChecklistPng} />
      </Button>
      <Modal open={open} sx={{ '.checmodel': { width: isMobile ? '90%' : '500px' } }}>
        <Box sx={{ ...style }} className="checmodel">
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '9999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    Checklist pour 'task.nom'
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                        {checkList.map((value) => {
                          const labelId = `checkbox-list-label-${value.id}`
                          return (
                            <ListItem key={value.id} disablePadding>
                              <ListItemButton
                                role={undefined}
                                onClick={handleToggle(value.id)}
                                dense
                              >
                                <ListItemIcon sx={{ minWidth: '0' }}>
                                  <Checkbox
                                    edge="start"
                                    checked={checked.indexOf(value.id) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                  />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={`${value.label}`} />
                              </ListItemButton>
                            </ListItem>
                          )
                        })}
                      </List>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '-webkit-fill-available',
                        }}
                      >
                        <Box sx={{ width: '-webkit-fill-available' }}>
                          <Input
                            control={control}
                            inputProps={{
                              variant: 'outlined',
                              required: true,
                              size: 'small',
                              type: 'text',
                            }}
                            rules={{ required: true }}
                            name="NomTask"
                            label={t('mesToDo.addItem')}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '0',
                            '& button': { minWidth: '0', color: '#434343', padding: '0' },
                          }}
                        >
                          <Button
                            onClick={() => {
                              toggleModal()
                            }}
                          >
                            <CalendarMonthIcon />
                          </Button>
                          <Button onClick={() => setShowContactModel(true)}>
                            <PersonAddAlt1Icon />
                          </Button>
                          <Button type="submit">
                            <AddIcon />
                          </Button>
                        </Box>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => addCheckList()}>{t('mesToDo.validate')}</Button>
                    </DialogActions>
                  </form>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      {showModal && (
        <CreateEvent isOpen={showModal} toggleModal={toggleModal} setEvent={setEvent} />
      )}
      {showContactModel && (
        <AddContact checkListContacts={setContacts} setShowContactModel={setShowContactModel} />
      )}
    </>
  )
}

export default function CreateTache({
  setCreateTache,
  updateTodo = false,
  row = false,
  projectTaskId = false,
  listeTaskId = false,
  operationFiId = false,
  onNoteDel = false,
  setTachePayload = false,
  setpayloadcheck = false,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modelOpen, setModelOpen] = useState(true)
  const [document, setDocument] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [checkListIds, setCheckListIds] = useState([])
  const [event, setEvent] = useState([])

  const [contacts, setContacts] = useState([])
  const [category, setCategory] = useState([])
  const [showContactModel, setShowContactModel] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  })
  const handleModelClose = () => {
    setModelOpen(false)
    setCreateTache(false)
    setSubmit(false)
    setDocument(false)
    setCheckListIds([])
    setEvent([])
    setContacts([])
    reset()
  }
  const priorite = [
    { label: 'Important et urgent', id: 1 },
    { label: 'Important et non urgent', id: 2 },
    { label: 'Non-important et urgent', id: 3 },
    { label: 'Non-important et non-urgent', id: 4 },
  ]
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Nom: row?.Titre ? row.Titre : '',
      Descriptions: row?.Details ? row.Details : '',
    },
  })

  useEffect(() => {
    fetchCategory()
  }, [])

  const fetchCategory = async () => {
    const url = '/api/time/get-category-dd'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.name}`, id: v.id })
      })
      setCategory([...filterTypes])
    }
  }

  const onSubmit = async (data) => {
    if (!submit) return
    let payload = {}
    payload = {
      ...data,
      ProjectId: projectTaskId ? projectTaskId : null,
      ListeId: listeTaskId ? listeTaskId : null,
      OpfiId: operationFiId ? operationFiId : null,
      EventData: event,
      Contacts: contacts,
      CheckListId: checkListIds,
      Priorite: data.Priorite.label,
      Categorie: data.Categorie.id,
    }
    if (setpayloadcheck) {
      setTachePayload(payload)
      handleModelClose()
    } else {
      const response = await makePostRequest(urls.taskOperations, payload, {}, true)
      if (response.status === 201) {
        if (document) document.append('TaskMesToDo', response.data.id)
        else handleModelClose()
        await makePostRequest(urls.crudDocumentsDetailsOperations, document, {}, true)
        if (row) {
          onNoteDel(row.id)
        }
        handleModelClose()
        console.log('call')
      }
      if (updateTodo) {
        updateTodo()
      }
    }
  }

  return (
    <>
      <Modal
        open={modelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: 'scroll', '.tachmo': { width: isMobile ? '90%' : '500px' } }}
      >
        <Box className="tachmo" sx={mstyle}>
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleModelClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    {t('mesToDo.newTask')}
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'text',
                        }}
                        rules={{ required: true }}
                        name="Nom"
                        label="Nom"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: false,
                          size: 'small',
                          type: 'text',
                        }}
                        rows={4}
                        multiline
                        rules={{ required: false }}
                        name="Descriptions"
                        label={t('mesToDo.description')}
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          // required: true,
                          size: 'small',
                          type: 'date',
                        }}
                        // rules={{ required: true }}
                        name="DateLimite"
                        label={t('mesToDo.fieldDueDate')}
                        InputLabelProps={{ shrink: true }}
                      />

                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Priorite', j)
                        }}
                        label="Priorite"
                        data={priorite}
                        name="Priorite"
                        required={true}
                      />
                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Categorie', j)
                        }}
                        label={t('mesToDo.fieldCategory')}
                        data={category}
                        name="Categorie"
                        required={true}
                      />

                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: false,
                          size: 'small',
                          type: 'number',
                        }}
                        rules={{ required: false }}
                        name="Couts"
                        label={t('mesToDo.fieldCosts')}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '0',
                          '& Button': { minWidth: '0', color: '#434343', padding: '0' },
                        }}
                      >
                        <Button onClick={() => setSubmit(false)}>
                          <CheckListModal setCheckListIds={setCheckListIds} />
                        </Button>
                        <Button onClick={() => setSubmit(false)}>
                          <CreateDocumentsForm setDocument={setDocument} />
                        </Button>
                        <Button
                          onClick={() => {
                            setSubmit(false)
                            toggleModal()
                          }}
                        >
                          <CalendarMonthIcon />
                        </Button>
                        <Button
                          onClick={() => {
                            setSubmit(false)
                            setShowContactModel(true)
                          }}
                        >
                          <PersonAddAlt1Icon />
                        </Button>
                      </Box>
                      <Button
                        sx={{ marginLeft: 'auto !important' }}
                        onClick={() => setSubmit(true)}
                        type="submit"
                      >
                        {t('mesToDo.validate')}
                      </Button>
                    </DialogActions>
                  </form>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      {showModal && (
        <CreateEvent isOpen={showModal} toggleModal={toggleModal} setEvent={setEvent} />
      )}
      {showContactModel && (
        <AddContact checkListContacts={setContacts} setShowContactModel={setShowContactModel} />
      )}
    </>
  )
}
